import React from 'react';
import { URLS, COMPANY_INFO } from '../../data/constants';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="wrap">
        <p>
          {COMPANY_INFO.name} · {URLS.email} · <a href={URLS.website}>{URLS.website}</a><br />
          {URLS.location} · Atendimento presencial e online
        </p>
      </div>
    </footer>
  );
};

export default Footer;
